import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../../services/i18n/language';

/**
 * Согласие с Пользовательским соглашением и Политикой конфиденциальности.
 * mode="checkbox" — обязательная галочка «Принимаю соглашение и политику» (control с Validators.requiredTrue);
 * mode="personal-data" — отдельная обязательная галочка согласия на обработку персональных данных;
 * mode="notice" — строка «Продолжая, вы принимаете условия… и даёте согласие…» под кнопкой.
 * Документы открываются в новой вкладке, чтобы не потерять заполненную форму.
 */
@Component({
  selector: 'app-legal-consent',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './legal-consent.component.html',
  styleUrl: './legal-consent.component.scss'
})
export class LegalConsentComponent implements OnInit, OnDestroy {
  @Input() mode: 'checkbox' | 'personal-data' | 'notice' = 'checkbox';
  @Input() control: AbstractControl | null = null;

  private subscription?: Subscription;

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  get showError(): boolean {
    return !!this.control && this.control.invalid && this.control.touched;
  }

  ngOnInit(): void {
    this.subscription = this.languageService.getTranslations().subscribe(() => this.cdr.markForCheck());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  t(key: string): string {
    const value = this.languageService.translate(`legal.consent.${key}`);
    return value === `legal.consent.${key}` ? '' : value;
  }
}
